// * * * * * * * * * * * * * * * * * * * * 
//
// On donne le focus à la fenetre du site et non au navigateur
//
// * * * * * * * * * * * * * * * * * * * * 
$(window).focus()

// * * * * * * * * * * * * * * * * * * * *
//
// DOM READY : init function
//
// * * * * * * * * * * * * * * * * * * * *
$(document).ready(function () {
        fn_media_querie();
        fn_scroll_top();
        fn_cover();
        fn_sticky();
        fn_header_move_up();
        fn_navigation_rwd();
        fn_owl_carousel();
        fn_scroll_next_section();
        fn_svg_inline();
        fn_float_label();
        fn_form_invalid();
        fn_search_nav();
        fn_masthead();
        fn_hide_streak();
//
})
